import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useEffect, useRef } from 'react';
import { HOOK_FIELD_IMAGES__get_fields_to_render } from '../../../_hooks/HOOK_FIELD_IMAGES__get_fields_to_render';
import { G_UI_FIELD__wrapper } from '../../../sidebar/_base/G_UI_FIELD__wrapper';
import { G_UI_FIELD__image_asset } from '../../../sidebar/image_asset/G_UI_FIELD__image_asset';
import { G_UI_FIELD__image_asset_list } from '../../../sidebar/image_asset_list/G_UI_FIELD__image_asset_list';
import { G_BAR__images_fields_buttons } from './G_BAR__images_fields_buttons';

export function G_SIDEBAR__fields_images() {
  const { g_image_edit__field } = use_slice_ui(['g_image_edit__field']);

  const ref_container = useRef<HTMLDivElement>(ENUM__html_ref_stub.DIV);

  const { fields_images, fields_images_lists } = HOOK_FIELD_IMAGES__get_fields_to_render();

  /*
   * EFFECTS
   */
  useEffect(() => {
    if (g_image_edit__field.is_stub()) return;

    // Find the DOM node corresponding to the active field inside this container
    const active_element = ref_container.current.querySelector(`[data-field-id="${g_image_edit__field.meta.field_id}"]`);

    if (active_element) {
      // Use requestAnimationFrame to ensure the DOM layout has settled before scrolling
      // "nearest" Prevents jumping the whole page, shifts container minimally
      requestAnimationFrame(() => active_element.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
    }
  }, [g_image_edit__field]);

  /*
   * RENDERS
   */

  function render_field_image(field: FIELD__image_asset) {
    return (
      <G_UI_FIELD__wrapper key={field.meta.field_id} {...{ field }}>
        <G_UI_FIELD__image_asset
          {...{ field }}
          class_name={`${g_image_edit__field.meta.field_id == field.meta.field_id ? 'opacity-100' : 'opacity-25'} hover:opacity-100`}
        />
      </G_UI_FIELD__wrapper>
    );
  }
  function render_field_image_list(field: FIELD__list_image_asset) {
    //todo: use
    // class_name={`${g_image_edit__field.meta.field_id == field.meta.field_id ? 'opacity-100' : 'opacity-25'} hover:opacity-100`}
    return (
      <G_UI_FIELD__wrapper key={field.meta.field_id} {...{ field }}>
        <G_UI_FIELD__image_asset_list {...{ field }} />
      </G_UI_FIELD__wrapper>
    );
  }

  return (
    <div ref={ref_container} className="flex flex-col size-full overflow-y-auto">
      <G_BAR__images_fields_buttons />
      {fields_images_lists.map(render_field_image_list)}
      {fields_images.map(render_field_image)}
    </div>
  );
}
